export default __webpack_public_path__ + "static/media/banner.de87c664.png";